export default "__VITE_ASSET__CPWBAuqT__"